import React from 'react'
interface IProps {
  agentValue: any
}

const TaskCard: React.FC<IProps> = ({ agentValue }) => {
  return (
    <>
      <div className='col-xl-4 col-lg-6 col-md-6 col-xm-12'>
        <div
          className='card cursor-pointer'
          style={{
            background: '#21ce78',
            color: 'black',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
          }}
        >
          <div className='card-body'>
            <div className='d-flex align-items-start justify-content-between'>
              <div className='content-left'>
                <span className='fw-bolder fs-6 text-white'>Total Conversation</span>
                <div className='d-flex align-items-end mt-2'>
                  <h4 className='mb-0 me-2 fs-1 text-white'>{agentValue[0]?.totalConversations}</h4>
                </div>
              </div>
              <div className='avatar'>
                <span className='avatar-initial rounded bg-label danger'>
                  <i
                    className='bi bi-chat-dots-fill bg-white rounded p-4 h3'
                    style={{ color: '#21ce78' }}
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-4 col-lg-6 col-md-6 col-xm-12'>
        <div
          className='card cursor-pointer'
          style={{
            background: '#ff0066',
            color: 'black',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
          }}
        >
          <div className='card-body'>
            <div className='d-flex align-items-start justify-content-between'>
              <div className='content-left'>
                <span className='fw-bolder fs-6 text-white'>Total Conversation Resolved</span>
                <div className='d-flex align-items-end mt-2'>
                  <h4 className='mb-0 me-2 fs-1 text-white'>
                    {agentValue[0]?.totalConversationsResolved}
                  </h4>
                </div>
              </div>
              <div className='avatar'>
                <span className='avatar-initial rounded bg-label danger'>
                  <i
                    className='bi bi-chat-dots-fill bg-white rounded p-4 h3'
                    style={{ color: '#ff0066' }}
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className='col-xl-4 col-lg-6 col-md-6 col-xm-12'>
        <div
          className='card cursor-pointer'
          style={{
            background: '#ff9d26',
            color: 'black',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
          }}
        >
          <div className='card-body'>
            <div className='d-flex align-items-start justify-content-between'>
              <div className='content-left'>
                <span className='fw-bolder fs-6 text-white'>Total Conversation Escalated</span>
                <div className='d-flex align-items-end mt-2'>
                  <h4 className='mb-0 me-2 fs-1 text-white'>
                    {agentValue[0]?.totalConversationsEscalated}
                  </h4>
                </div>
              </div>
              <div className='avatar'>
                <span className='avatar-initial rounded bg-label danger'>
                  <i
                    className='bi bi-chat-dots-fill bg-white rounded p-4 h3'
                    style={{ color: '#ff9d26' }}
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <div className='col-xl-3 col-lg-6 col-md-6 col-xm-12'>
        <div
          className='card cursor-pointer'
          style={{
            background: '#862ee0',
            color: 'black',
            boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 12px'
          }}
        >
          <div className='card-body'>
            <div className='d-flex align-items-start justify-content-between'>
              <div className='content-left'>
                <span className='fw-bolder fs-6 text-white'>Escalations</span>
                <div className='d-flex align-items-end mt-2'>
                  <h4 className='mb-0 me-2 fs-1 text-white'>{agentValue?.escalations}</h4>
                </div>
              </div>
              <div className='avatar'>
                <span className='avatar-initial rounded bg-label danger'>
                  <i
                    className='bi bi-people-fill bg-white rounded p-4 h3'
                    style={{ color: '#862ee0' }}
                  ></i>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default TaskCard
